import { useBreakpoint } from "hooks/use-breakpoint";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectDestinations } from "store/quote/selectors";
import { googlePlacesGetDetails } from "utils/google-places";
import { sentryCaptureError } from "utils/tracking/sentry";
import fallbackDestinationUrl from "assets/images/fallback-destination.svg?url";
import { Picture, PictureContainer, ProfileLogo } from "./styles";

export const DestinationPicture = () => {
  const destinations = useSelector(selectDestinations);
  const [pictureSrc, setPictureSrc] = useState<string>();
  const mdBreakpoint = useBreakpoint("md", { noSsr: true });

  useEffect(() => {
    if (!destinations?.length || !mdBreakpoint || pictureSrc) return;

    googlePlacesGetDetails(destinations[0].googleId, { fields: ["photos"] })
      .then(({ photos }) => {
        setPictureSrc(
          photos?.[0]?.getUrl({ maxWidth: 960 }) || fallbackDestinationUrl,
        );
      })
      .catch((error) => {
        sentryCaptureError(error, {
          contexts: { destination: { ...destinations[0] } },
          name: "Destination_photo_load_failed",
        });
        setPictureSrc(fallbackDestinationUrl);
      });
  }, [mdBreakpoint, pictureSrc, destinations]);

  return (
    <>
      <PictureContainer>
        {pictureSrc && (
          <Picture
            alt=""
            src={pictureSrc}
            onError={() => {
              setPictureSrc(fallbackDestinationUrl);
            }}
          />
        )}
      </PictureContainer>
      <ProfileLogo />
    </>
  );
};
